const VOICE_CONNECTING = 0;
const VOICE_CONNECTED = 1;
const VOICE_DISCONNECTED = 2;
const VOICE_ERROR = 3;
const VOICE_LISTENING = 4;
const VOICE_THINKING = 5;
const VOICE_SPEAKING = 6;
const VOICE_PAUSED = 7;
const VOICE_HANGED_UP = 8;

export const getVoiceStatus = (status) => {
  switch(status) {
    case 0:
      return 'Connecting...';
    case 1:
      return 'Please tap on the Mic to speak';
    case 2:
      return 'Disconnected';
    case 3:
      return 'Error';
    case 4:
      return 'Listening...';
    case 5:
      return 'Thinking...';
    case 6:
      return 'Speaking...';
    case 7:
        return 'Muted';
    case 8:
        return 'Hanged Up';
    default:
      return 'Unknown';
  }
}

export { VOICE_CONNECTING, VOICE_CONNECTED, VOICE_DISCONNECTED, VOICE_ERROR, VOICE_LISTENING, VOICE_THINKING, VOICE_SPEAKING, VOICE_PAUSED, VOICE_HANGED_UP };